import {
    Alert,
    Button,
    Col,
    Container,
    Icon,
    Modal,
    Row,
    Table,
    TextArea
} from "design-react-kit";
import React, {useEffect, useState} from "react";
import {properties} from "../../../config/properties";
import { useLocation,useNavigate } from "react-router-dom";
import Spinner from "../../layout/Spinner";
import SpinnerCustom from "../../layout/Spinner";

// Stili unificati, riutilizzati dall'esempio fornito
const styles = {
    tableContainer: {
        resize: 'vertical',
        minHeight: '20vh', // Imposta un'altezza massima (es. 60% dell'altezza del viewport)

        height: '70vh', // Imposta un'altezza massima (es. 60% dell'altezza del viewport)
        maxHeight: 'max-content',
        overflowY: 'auto', // Mostra la scrollbar verticale solo se necessario
        // border: '1px solid #e0e0e0',  Bordo sottile per definire l'area di scroll

    },
    tableHeader: {
        borderBottom: '2px solid #dee2e6',
        backgroundColor: '#06c',
        color: 'white',
        textTransform: 'uppercase',
        fontWeight: 600,
        fontSize: '1.25rem',
        letterSpacing: '0.05em',
        // --- Proprietà per lo sticky header ---
        position: 'sticky',
        top: 0, // Si "attacca" al bordo superiore del contenitore di scroll
        zIndex: 1 // Assicura che l'header stia sopra il contenuto della tabella
    },
    tableRowText: {
        color: '#333',
        fontWeight: 500, // Regular/Medium per una migliore leggibilità
        fontSize: "1rem",
        verticalAlign: 'middle', // Allinea verticalmente il testo
        textAlign: "left"
    },
    actionButton: {
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        padding: '0.5rem'
    },
    formContainer: {
        backgroundColor: '#ffffff',
        padding: '2rem',
        borderRadius: '8px',
        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.07)',
        border: '1px solid #dee2e6'
    },
    formTitle: {
        fontSize: '1.5rem',
        fontWeight: '600',
        color: '#333',
        marginBottom: '1.5rem',
    },
    buttonGroup: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '0.75rem',
    },
    highlightedRow: {
        backgroundColor: 'rgba(0, 102, 204, 0.1)',
        transition: 'background-color 0.3s ease-in-out',
    }
};

// --- Componente per il Form di Modifica Delega ---
const FormModificaDelega = ({delega, onSave, onCancel, user}) => {
    const [descrizione, setDescrizione] = useState('');
    const [note, setNote] = useState('');
    const [error, setError] = useState(null);
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        if (delega) {
            setDescrizione(delega.descDelega);
            setNote(delega.noteDelega || ''); // Gestisce il caso in cui le note siano null
        }
    }, [delega]);

    const handleConfirm = async (e) => {
        e.preventDefault();
        setIsSaving(true);
        setError(null);

        try {

            const response = await fetch(`${properties.fullBaseUrl}${properties.baseAppUrl}/std/service/update/delega`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({descrizione, note, id: delega.id, userID : user.userID, cciaa : user.cciaa , gruppoUtente: user.gruppoUtente})
            });

            if(response.status === 401){

                const datasResponse = await response.json();

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                setError("Errore di comunicazione con il server.");
                return;


            }

            const result = await response.json();
            if (result.esito === "OK") {
                onSave(); // Notifica il successo al componente genitore
            } else {
                setError(result.messaggio || "Operazione fallita");
            }
        } catch (err) {
            setError("Errore di rete o server non raggiungibile.");
        } finally {
            setIsSaving(false);
        }
    };

    if (!delega) return null;

    return (
        <div style={styles.formContainer}>
            <h3 style={styles.formTitle}>Modifica Delega</h3>
            {error && <Alert color="danger">{error}</Alert>}
            <form onSubmit={handleConfirm}>
                <TextArea
                    id="descrizione"
                    label="Descrizione Delega"
                    value={descrizione}
                    onChange={(e) => setDescrizione(e.target.value)}
                    rows={4}
                    required
                    maxLength={500}
                    wrapperClass="mb-3"
                />
                <TextArea
                    id="note"
                    label="Note (opzionale)"
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                    rows={3}
                    maxLength={500}
                />
                <div className="mt-4" style={styles.buttonGroup}>
                    <Button className="btn btn-outline-secondary" outline type="button" onClick={onCancel}>
                        Annulla
                    </Button>
                    <Button className="btn btn-outline-primary" type="submit" disabled={isSaving}>
                        {isSaving ? 'Salvataggio...' : 'Salva'}
                    </Button>
                </div>
            </form>
        </div>
    );
};

// --- Componente Principale per la Gestione Deleghe ---
const GestioneDeleghe = ({user}) => {
    const navigate = useNavigate();

    const [deleghe, setDeleghe] = useState([]);
    const [alert, setAlert] = useState({visible: false, type: '', message: ''});
    const [delegaInModifica, setDelegaInModifica] = useState(null);
    const [delegaToDelete, setDelegaToDelete] = useState(null);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [loadingUser, setLoadingUser] = useState(true);
    const location = useLocation();

    // Funzione per caricare i dati
    const fetchDeleghe = async () => {

        try{

            const data = await getDelegheList();
            setDeleghe(data?.deleghe ?? []);
        }catch(e){
            setDeleghe([]);
        }
    };

    useEffect(() => {
        fetchDeleghe();
    }, []);


    useEffect(() => {
        if (location.state?.esito) {
            setAlert({ visible: false, type: '', message: '' });
            const message = location.state.esito.messaggio;
            const type = location.state.esito.esito === "OK" ? 'success' : 'danger';
            setAlert({visible: true, type, message});
            window.scrollTo({top: 0, behavior: 'smooth'});
        }
        navigate(location.pathname, { replace: true });
    }, [location.state]);

    // --- Gestori di Azioni ---
    const handleEditClick = (delega) => {
        setDelegaInModifica(delega);
        setAlert({ visible: false, type: '', message: '' });
    };

    const handleCancelEdit = () => {
        setDelegaInModifica(null);
    };

    const handleSaveSuccess = () => {
        setDelegaInModifica(null);
        setAlert({visible: true, type: 'success', message: 'Delega aggiornata con successo!'});
        window.scrollTo({top: 0, behavior: 'smooth'});
        fetchDeleghe();
    };

    const openDeleteConfirm = (delega) => {
        setDelegaToDelete(delega);
        setShowConfirmModal(true);
    };

    const closeDeleteConfirm = () => {
        setDelegaToDelete(null);
        setShowConfirmModal(false);
    };

    const confirmDelete = async () => {

        setAlert({ visible: false, type: '', message: '' });
        if (!delegaToDelete) return;

        try {
            const res = await fetch(`${properties.fullBaseUrl}${properties.baseAppUrl}/std/service/delete/delega`, {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({id: delegaToDelete.id, userID: user.userID, cciaa: user.cciaa, gruppoUtente:user.gruppoUtente}),
            });

            if(res.status === 401){

                const datasResponse = await res.json();

                setAlert({visible: true, type: 'danger', message: 'Errore di comunicazione con il server.'});
                window.scrollTo({top: 0, behavior: 'smooth'});

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return;

            }

            const json = await res.json();

            if (json.esito === "OK") {
                setAlert({visible: true, type: 'success', message: 'Delega eliminata correttamente.'});
                window.scrollTo({top: 0, behavior: 'smooth'});
                fetchDeleghe();
            } else {
                setAlert({
                    visible: true,
                    type: 'danger',
                    message: json.messaggio || 'Errore: non è possibile eliminare una delega assegnata.'
                });
                window.scrollTo({top: 0, behavior: 'smooth'});
            }
        } catch (e) {
            setAlert({visible: true, type: 'danger', message: 'Errore di rete o server non raggiungibile.'});
            window.scrollTo({top: 0, behavior: 'smooth'});
        } finally {
            closeDeleteConfirm();
        }
    };


    // Funzione helper per recuperare i dati (resa più robusta)
    async function getDelegheList() {

        try {

            setLoadingUser(true);

            const res = await fetch(`${properties.fullBaseUrl}${properties.baseAppUrl}/std/service/list/deleghe`, {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({userID: user.userID, cciaa: user.cciaa, gruppoUtente:user.gruppoUtente}),

            });

            if(res.status === 401){

                const datasResponse = await res.json();

                setAlert({visible: true, type: 'danger', message: 'Errore di comunicazione con il server.'});
                window.scrollTo({top: 0, behavior: 'smooth'});

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return[];

            }

            if (!res.ok) throw new Error(`Errore HTTP: ${res.status}`);
            return await res.json();

        } catch (e) {


            setAlert({visible: true, type: 'danger', message: 'Errore di rete o server non raggiungibile.'});
            return []; // Ritorna un array vuoto in caso di errore per evitare crash
        } finally {
            setLoadingUser(false);
        }
    }


    if (loadingUser) {
        // Puoi mostrare uno spinner o scritta di caricamento


        return (

            <Container fluid className="vh-100 d-flex justify-content-center align-items-center bg-light">

                <p className="mb-3">
                    <strong>
                        Caricamento
                    </strong>
                </p>
                <SpinnerCustom active/>


            </Container>
        );


    }

    return (
        <div className="bg-white py-5 py-lg-6">
            <Container>
                <h2 className="mb-5">Gestione Deleghe</h2>

                {alert.visible && (
                    <Alert color={alert.type} isOpen={alert.visible} toggle={() => setAlert({...alert, visible: false})}>
                        {alert.message}
                    </Alert>
                )}

                <Row>
                    {(
                        <Col md={4} hidden={delegaInModifica} className="transition-all duration-300">
                            <Container>

                                <div className="guidance-box lead">
                                    <p>
                                        Crea una nuova delega per modellare l'esperienza sulla nostra
                                        piattaforma. Inizia con un nome chiaro e rappresentativo, poi cura
                                        la descrizione se desiderato.
                                    </p>

                                    <div style={{display:'flex'}}>
                                        <div style={{flex:1, padding:"1.68%"}} align={"right"}>
                                            <Button className="btn btn-outline-primary" outline onClick={() => {
                                                navigate('/private/inserimentoDelega')
                                            }}> Inserisci Delega</Button>
                                        </div>


                                    </div>



                                </div>



                            </Container>
                        </Col>
                    )}

                    {/* Colonna Sinistra: Tabella delle Deleghe */}
                    <Col md={delegaInModifica && 8} className="transition-all duration-300">
                            <Table  hover>
                                <thead>
                                <tr>
                                    <th scope="col" className="text-left" style={{...styles.tableHeader, width: '45%'}}>Descrizione</th>
                                    <th scope="col" className="text-left" style={{...styles.tableHeader, width: '40%'}}>Note</th>
                                    <th scope="col" className="text-left" style={{...styles.tableHeader, width: '15%'}}>Azioni</th>
                                </tr>
                                </thead>

                            </Table>
                        <div style={styles.tableContainer} className="custom-scrollbar">
                            <Table  hover>
                             <tbody>
                                {deleghe.length > 0 ? (
                                    deleghe.map((delega) => {
                                        const isHighlighted = delegaInModifica && delega.id === delegaInModifica.id;
                                        return (
                                            <tr key={delega.id} style={isHighlighted ? styles.highlightedRow : undefined}>
                                                <td className="text-left" style={{...styles.tableRowText, width: '45%', height:"100px"}} >{delega.descDelega}</td>
                                                <td  className="text-left" style={{...styles.tableRowText, width: '40%', height:"100px"}}>{delega.noteDelega}</td>
                                                <td className="text-left" style={{...styles.tableRowText, width: '15%', height:"100px"}} >
                                                    <button className={"action-icon"} style={styles.actionButton} onClick={() => handleEditClick(delega)} aria-label={`Modifica ${delega.descDelega}`}>
                                                        <Icon icon="it-pencil" color="primary"/>
                                                    </button>
                                                    <button  className={"action-icon"} style={styles.actionButton} onClick={() => openDeleteConfirm(delega)} aria-label={`Elimina ${delega.descDelega}`}>
                                                        <Icon icon="it-delete" color="danger"/>
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="3" className="text-center" style={styles.tableRowText}>
                                            Nessuna delega trovata.
                                        </td>
                                    </tr>
                                )}
                                </tbody>
                            </Table>
                        </div>

                        {deleghe.length > 0 && (
                            <>
                                <Row className="mt-2">
                                    <Col className="text-end">
                                        <small className="text-muted">
                                            <strong>{deleghe.length}</strong>  risultati
                                        </small>
                                    </Col>
                                </Row>

                            </>
                        )}
                    </Col>

                    {/* Colonna Destra: Form di Modifica (visibile condizionalmente) */}
                    {delegaInModifica && (
                        <Col md={4} className="transition-all duration-500">
                            <FormModificaDelega
                                delega={delegaInModifica}
                                onSave={handleSaveSuccess}
                                onCancel={handleCancelEdit}
                                user={user}
                            />


                        </Col>
                    )}
                </Row>
                <Spinner active = {!setDeleghe}/>

            </Container>

            {/* Modale di Conferma Eliminazione */}
            <Modal isOpen={showConfirmModal} toggle={closeDeleteConfirm} centered>
                <div className="modal-header">
                    <h5 className="modal-title">Conferma Eliminazione</h5>
                    <button type="button" className="btn-close" aria-label="Close" onClick={closeDeleteConfirm}></button>
                </div>
                <div className="modal-body">
                    Sei sicuro di voler eliminare la delega: <strong>{delegaToDelete?.descDelega}</strong>?
                    <br/>
                    L'azione non potrà essere annullata.
                </div>
                <div className="modal-footer">
                    <Button color="secondary" outline onClick={closeDeleteConfirm}>Annulla</Button>
                    <Button color="danger" onClick={confirmDelete}>Conferma ed Elimina</Button>
                </div>
            </Modal>
        </div>
    );
};



export default GestioneDeleghe;